// src/components/structure/DraggableHeaderCell.js
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from 'baseui/button';
import { StatefulPopover, PLACEMENT } from 'baseui/popover';
import { HeaderContent, Label, MenuContainer, StyledDraggableHeaderCell } from '../../styles/controllerPageStyles';
import { useLocale } from '../../contexts/LocaleContext';

const DraggableHeaderCell = ({
  id,
  colName,
  isFixedColumn,
  canEditColumns,
  onDeleteColumn,
  onInsertColumn,
  onRenameColumn
}) => {
  const { t } = useLocale();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled: !canEditColumns || isFixedColumn,
  });



  const handleRename = () => {
    const newLabel = window.prompt(t('structure.renameColumnPrompt'), colName);
    if (newLabel) {
      onRenameColumn(newLabel);
    }
  };

  const ColumnMenu = (
    <StatefulPopover
      placement={PLACEMENT.bottomLeft}
      content={({ close }) => (
        <MenuContainer>
          <Button size="mini" onClick={() => { onInsertColumn(); close(); }}>
            {t('structure.addColumnAfter')}
          </Button>
          {!isFixedColumn && (
            <>
              <Button size="mini" onClick={() => { handleRename(); close(); }}>
                {t('structure.renameColumn')}
              </Button>
              <Button size="mini" onClick={() => { onDeleteColumn(); close(); }} kind="secondary">
                {t('structure.deleteColumn')}
              </Button>
            </>
          )}
        </MenuContainer>
      )}
    >
      <Button size="mini" kind="tertiary" shape="square" aria-label={t('structure.columnActions')}>
        ⋮
      </Button>
    </StatefulPopover>
  );

  return (
    <StyledDraggableHeaderCell ref={setNodeRef} $transform={CSS.Transform.toString(transform)} $transition={transition} $isDragging={isDragging} $canEditColumns={canEditColumns} $isFixedColumn={isFixedColumn} {...attributes}>
      <HeaderContent>
        {canEditColumns && !isFixedColumn && (
          <span {...listeners} tabIndex={0} title={t('structure.dragToReorderColumn')}>☰</span>
        )}
        <Label>{colName}</Label>
        {canEditColumns && colName !== 'time' && (
          <div>{ColumnMenu}</div>
        )}
      </HeaderContent>
    </StyledDraggableHeaderCell>
  );
};

export default DraggableHeaderCell;
